<template>
  <div>
    <cadastro-base :salvar="salvar">
      <template slot="conteudo">
        <b-row>
          <b-form-group
            label="Nome"
            class="col-12"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Nome"
            >
              <b-form-input
                v-model="form.nome"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-row>

        <b-row>
          <b-form-group
            label="Início da cobrança"
            class="col-6"
          >
            <b-select
              v-model="form.diaCobrancaDocumentos"
              @change="verificaSeDiaNulo"
            >
              <option :value="null" />
              <option
                v-for="$index in 31"
                :key="$index"
                :value="$index"
              >{{ $index }}</option>
            </b-select>
            <small class="form-text text-muted">
              Dia de início da cobrança de documentos
            </small>
          </b-form-group>

          <b-form-group
            label="Cobrar a cada"
            class="col-md-6"
          >
            <b-select
              v-model="form.cobrarDocumentosCada"
              :disabled="!form.diaCobrancaDocumentos"
            >
              <option :value="null" />
              <option
                v-for="$index in 31"
                :key="$index"
                :value="$index"
              >{{ $index == 1 ? $index + ' dia' : $index + ' dias' }}</option>
            </b-select>
            <small class="form-text text-muted">
              Intervalo de dias entre cada cobrança
            </small>
          </b-form-group>
        </b-row>

        <b-row>
          <b-form-group
            label="E-mail Cópia de Segurança (CCO) — Opcional"
            class="col-md-12"
          >
            <validation-provider
              #default="{ errors }"
              name="E-mail"
              rules="email"
            >
              <b-form-input
                ref="email"
                v-model="form.emailCopiaSeguranca"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-row>

        <b-row>
          <div
            style="display: flex;"
            class="col-md-12"
          >
            <div>
              <legend style="font-size: 14px;">
                Complemento (visível para o cliente)
              </legend>
            </div>
            <div style="padding-left: 0.4rem">
              <i
                v-b-tooltip.hover
                title="Atenção: essa descrição ficará visível para o cliente nos e-mails de notificações!"
                style="font-size: 0.65rem;"
                class="question-icon"
              >
                <font-awesome-icon
                  :icon="faQuestionCircle"
                />
              </i>
            </div>
          </div>
          <b-form-group
            class="col-12"
          >
            <b-textarea v-model="form.descricao" />
          </b-form-group>
        </b-row>
      </template>
    </cadastro-base>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/comuns/departamentos/shared/services/api'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'

export default {
  name: 'Departamentos',
  components: {
    CadastroBase,
    ValidationProvider,
    FontAwesomeIcon,
  },
  data() {
    return {
      faQuestionCircle,
      required,
      form: {
        nome: '',
        diaCobrancaDocumentos: null,
        cobrarDocumentosCada: null,
        descricao: '',
        emailCopiaSeguranca: '',
      },
      immutableForm: {},
      state: 'none',
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    carregar(id) {
      api.getDepartamento(id)
        .then(payload => {
          this.form = payload.data
        })
    },
    salvar() {
      return new Promise((resolve, reject) => {
        if (this.state === 'novo') {
          api.createDepartamento(this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Departamento cadastrado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        } else {
          api.updateDepartamento(this.form.id, this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Departamento alterado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    cancelar() {
      this.$router.go(-1)
    },
    verificaSeDiaNulo() {
      if (this.form.diaCobrancaDocumentos === null) {
        this.form.cobrarDocumentosCada = null
      }
    },
  },
}
</script>
